import React from "react";
import PropTypes from "prop-types";
import styles from "./ProgramDashboardTile.scss";
import Button from "components/common/Button";
import Image from "components/common/Image";

export default function ProgramDashboardTile(props) {
    return (
        <div
            className={styles.root}
            onClick={() => props.onButtonClick(props.program.programId)}
        >
            <div className="flex spaced-content align-center">
                <div className={styles.icon}>
                    <Image
                        src={props.program.programImage}
                        alt={props.program.programName}
                        title={props.program.programName}
                    />
                </div>
                <h4 className="flex-1">{props.program.programName}</h4>
                <div className={styles.button}>
                    <Button small onClick={() => {}}>
                        View
                    </Button>
                </div>
            </div>
        </div>
    );
}

ProgramDashboardTile.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    onButtonClick: PropTypes.func
};
